import { VISIBILITY_ANNOTATION_ACTION } from '../../../../common/constant/constant';
import type { ToggleVisibilityAnnotationPayloadT } from '../../../../common/side-panel/analytics/types';
import useAnalyticsForSidePanel from '../../../../common/side-panel/analytics/useAnalyticsForSidePanel';
import type { StoreTypeT } from '../../../../common/types/types';
import type { AnnotationInfoT } from '../../annotations/types';
import { SIDE_PANEL_ACTIONS } from '../../const';
import { useDispatch } from '../../hooks/use-dispatch';
import { useSelectedAnnotationLabel } from '../../hooks/use-selected-annotation-label';
type PropsT = {
  annotation: AnnotationInfoT;
  storeType: StoreTypeT;
};
export function useShowHideHandler({
  annotation,
  storeType
}: PropsT) {
  const dispatch = useDispatch();
  const selectedAnnotationLabel = useSelectedAnnotationLabel();
  const {
    sendEventForToggleVisibilityAnnotation
  } = useAnalyticsForSidePanel();
  const {
    id,
    isVisible
  } = annotation;
  const handleShowHideAnnotation = () => {
    dispatch({
      type: SIDE_PANEL_ACTIONS.SHOW_HIDE_ANNOTATIONS,
      annotationId: annotation.id,
      hidden: isVisible,
      storeType
    });
    const eventPayload: ToggleVisibilityAnnotationPayloadT = {
      objectType: SIDE_PANEL_ACTIONS.SHOW_HIDE_ANNOTATIONS,
      label: selectedAnnotationLabel?.title ?? '',
      objectId: id,
      action: isVisible ? VISIBILITY_ANNOTATION_ACTION.HIDE : VISIBILITY_ANNOTATION_ACTION.SHOW
    };
    sendEventForToggleVisibilityAnnotation(eventPayload);
  };
  return {
    handleShowHideAnnotation
  };
}